const FOCUSABLE = [
  'a[href]',
  'button',
  'input:not([type="hidden"])',
  'select',
  'textarea',
  '[tabindex]'
].join(', ')

// Wurde das Element per Tastatur fokussiert? Ältere Browser kennen
// :focus-visible nicht und werfen beim Selektor.
export const isFocusVisible = (element) => {
  try {
    return !!element?.matches(':focus-visible')
  } catch {
    return false
  }
}

const isTabbable = (candidate) =>
  candidate.tabIndex >= 0 &&
  !candidate.matches(':disabled') &&
  candidate.getClientRects().length > 0 &&
  !candidate.closest('[aria-hidden="true"], [inert]')

/**
 * Wohin der Fokus geht, bevor `element` aus dem DOM verschwindet. Erst das
 * nächste Bedienelement danach, sonst das letzte davor (z. B. in Leerzuständen
 * ohne Liste), sonst null. Gesucht wird im umgebenden <main>, damit der Fokus
 * nicht in Sidebar oder Overlays springt.
 */
export const getFocusTargetAfterRemoval = (element) => {
  if (!element) return null

  const candidates = [
    ...(element.closest('main') || document).querySelectorAll(FOCUSABLE)
  ].filter((candidate) => !element.contains(candidate) && isTabbable(candidate))

  const isFollowing = (candidate) =>
    element.compareDocumentPosition(candidate) &
    Node.DOCUMENT_POSITION_FOLLOWING

  return (
    candidates.find(isFollowing) ||
    candidates.filter((candidate) => !isFollowing(candidate)).pop() ||
    null
  )
}
